module.exports = "/_next/static/images/e3f77b9a12dd4e7168ea3dc9d8fbd742-instagram-icon.svg.webp";